module.exports = __webpack_public_path__ + "img/map_1791458174076_68500.b811a5a3.jpg";